import { deleteRequest } from '@/core';
import { incoterms } from '@/requests';
export default async function deleteIncotermRequest(idToDelete) {
	let url = incoterms.getByIdPath(idToDelete);
	return deleteRequest(url);
}